import { render } from "./AppMenu.vue?vue&type=template&id=20664e54"
import script from "./AppMenu.vue?vue&type=script&lang=js"
export * from "./AppMenu.vue?vue&type=script&lang=js"

import "./AppMenu.vue?vue&type=style&index=0&id=20664e54&lang=scss"

import exportComponent from "C:\\Users\\adria\\OneDrive\\Escritorio\\fintechmediafinance-front-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__